import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { ServicePlanFormData } from 'components/Assessments/ServicePlanAssessment/types/ServicePlanFormData'
import { FinalStepsFormField } from './formField'
import { FinalStepsQuestionnaireItem } from './questionnaire'

/**
 * Final Steps subsection adapter for Service Plan Assessment
 * Handles final steps extraction and transformation
 */
export class FinalStepsAdapter extends BaseSubsectionAdapter<ServicePlanFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<ServicePlanFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const finalStepsInternalNotes = getAnswerValuesFromItems(
      flatAnswersArray,
      FinalStepsQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES
    )?.at(0)
    const clientRepresentativeSignature = getAnswerValuesFromItems(
      flatAnswersArray,
      FinalStepsQuestionnaireItem.FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE
    )?.at(0)

    return {
      [FinalStepsFormField.FINAL_STEPS_INTERNAL_NOTES]: finalStepsInternalNotes,
      [FinalStepsFormField.FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE]:
        clientRepresentativeSignature
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(FinalStepsFormField.FINAL_STEPS_INTERNAL_NOTES)) {
      mutations.push({
        linkId: FinalStepsQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES,
        value: this.getFormDataField(FinalStepsFormField.FINAL_STEPS_INTERNAL_NOTES)
      })
    }

    if (this.formDataFieldExists(FinalStepsFormField.FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE)) {
      mutations.push({
        linkId: FinalStepsQuestionnaireItem.FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE,
        value: this.getFormDataField(
          FinalStepsFormField.FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE
        )
      })
    }

    return mutations
  }
}
